const css = `.LtWB-G__sizerRelative{height:100%;position:relative}.LtWB-G__sizerStretch{position:absolute;inset:0}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"sizerStretch":"LtWB-G__sizerStretch","sizerRelative":"LtWB-G__sizerRelative"};
